import { WebRTCCamera } from "../../pages/deployment/WebRTCCamera";
import { FPVCamera } from "../../panels/worldpanelparts/FpvCameraService";
import { RobotAgent } from "../../panels/worldpanelparts/robot/RobotAgent";
import { RobotVisual } from "../../visuals/RobotVisual";
import { BaseDataChannel, DataChannelConfiguration } from "./BaseDataChannel";
import * as THREE from "three";

// const height =  
export const DEFAULT_FRAME_SIZE = [1280, 720];

export class CameraChannel extends BaseDataChannel {
  public frameSize = DEFAULT_FRAME_SIZE;
  private fpvCamera: FPVCamera | null = null;
  private fpsInterval = 1000 / 2;

  private renderTarget = new THREE.WebGLRenderTarget(this.frameSize[0], this.frameSize[1]);
  private canvas: HTMLCanvasElement = document.createElement("canvas");
  public pixels = new Uint8Array(this.frameSize[0] * this.frameSize[1] * 4);
  public grayscalePixels = new Uint8Array(this.frameSize[0] * this.frameSize[1]);

  public getConfiguration(): DataChannelConfiguration {
    return {
      name: "camera",
    };
  }

  public onMessage(ev: MessageEvent): void {
    // throw new Error("Method not implemented.");
  }

  protected onConnected(): void {
  }

  public streamToCamera(camera: WebRTCCamera) {

  }

  public connectToCamera(fpvCamera: FPVCamera) {
    console.log({ sm: this.stateManager});
    if (this.stateManager instanceof RobotAgent) {
      const robot = this.stateManager as RobotAgent;
      console.log('robot manifest: ', robot.manifest);
      try {
        const robotVisual = robot.visual as RobotVisual;
        const activeCamera = robotVisual.getCameras()[0];
        if (!activeCamera || !robotVisual.manifest) {
          console.warn("No active camera found on robot visual or manifest missing");
          return;
        }
        // console.log('active camera: ', activeCamera);
        const video = robotVisual.manifest!.sim.sensors[activeCamera.name];
        this.frameSize = [
          video.frame.width,
          video.frame.height
        ];
        this.renderTarget = new THREE.WebGLRenderTarget(this.frameSize[0], this.frameSize[1]);
        this.pixels = new Uint8Array(this.frameSize[0] * this.frameSize[1] * 4);
        this.grayscalePixels = new Uint8Array(this.frameSize[0] * this.frameSize[1]);
        this.fpsInterval = 1000 / video.frequency;
        console.log("CameraChannel frame size: ", this.frameSize, " fps interval: ", this.fpsInterval);
      } catch (e) {
        console.error("Error getting camera resolution from manifest: ", e);
        this.frameSize = DEFAULT_FRAME_SIZE;
        return;
      }
      // console.log(`using frame size: ${this.frameSize}`); 
    } else {
      console.warn("CameraChannel not connected to a robot actor: ", this.stateManager);
      return;
    }

    this.fpvCamera = fpvCamera;
    this.captureFrame();
  }

  public disconnectFromCamera() {
    this.fpvCamera = null;
  }

  public async captureFrame(): Promise<void> {
    if (!this.fpvCamera) {
      return;
    }
    if (this.isConnected()) {
      const { scene, camera, renderer } = this.fpvCamera;

      renderer.setRenderTarget(this.renderTarget); // Render to the target
      renderer.render(scene, camera);
      renderer.setRenderTarget(null); // Reset to default framebuffer
      this.fpvCamera.renderer.readRenderTargetPixels(
        this.renderTarget, 0, 0,
        this.frameSize[0],
        this.frameSize[1],
        this.pixels);

      // flip the image
      for (let y = 0; y < this.frameSize[1] / 2; y++) {
        for (let x = 0; x < this.frameSize[0]; x++) {
          const index1 = (y * this.frameSize[0] + x) * 4;
          const index2 = ((this.frameSize[1] - y - 1) * this.frameSize[0] + x) * 4;
          const temp = this.pixels.slice(index1, index1 + 4);
          this.pixels.copyWithin(index1, index2, index2 + 4);
          this.pixels.set(temp, index2);
        }
      }
      const blob = await this.pixelsToJpeg(this.pixels);
      const buffer = await blob.arrayBuffer();
      // console.log("CameraChannel sending data: ", buffer.byteLength);
      this.sendBytes(buffer);
    }
    setTimeout(() => {
      this.captureFrame();
    }, this.fpsInterval);
  }

  private pixelsToJpeg(rawPixels: Uint8Array): Promise<Blob> {
    return new Promise((resolve) => {
      // Create a canvas element
      const ctx = this.canvas.getContext("2d")!;
      const width = this.frameSize[0];
      const height = this.frameSize[1];
      this.canvas.width = width;
      this.canvas.height = height;

      // Create ImageData from raw pixel buffer (RGBA)
      const imageData = new ImageData(new Uint8ClampedArray(rawPixels), width, height);
      ctx.putImageData(imageData, 0, 0);

      // Convert to PNG (async)
      this.canvas.toBlob((blob) => {
        if (blob) resolve(blob);
      }, "image/jpeg", 0.95); // Adjust quality as needed
    });
  }

}
